module.exports = __webpack_public_path__ + "static/media/belek-aki.6a7b7164.jpg";